import React, { useCallback, useMemo, useState } from "react";
import dynamic from "next/dynamic";
import { create } from "@/src/models/basket";
import { NOTIFY } from "@/config/api";
import { postAccount } from "@/src/models/account";
import { isLogin } from "@/src/models/loginModel";
import stl from "./selectLenses.module.scss";
import { getPackageUsage } from "@/src/utils/lensComponents/lensBar/addCart";
import { LensPageDiversion } from "@/src/components/LoadAnalysis/analysis/abTest";
const NeckglassesModal = dynamic(import("../NeckglassesModal"));

//ga统计事件
import {
    getProductItemParams,
    productAddToCar,
    gaSelectLensBtnClick,
    gaLensPackageEvent,
    gaCommonEvent,
} from "@/src/utils/gtagEvents";
import { snapProductAddToCar } from "@/src/utils/snapEvents";
import { addToCartClickEvent } from "@/src/models/emailData";
import criteoAd from "@/src/components/LoadAnalysis/analysis/criteo";
import {
    useCommonContext,
    usePackageInfoContext,
    useProductDetailsContext,
} from "@/src/provider";
import { lensObj, signInModal } from "@/store";
import { FmButton, FmDrawer, FmToast } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";

interface Props {
    localHref?: string;
    style?: any;
    selecUsagetNotice?: () => void;
    pageId?: number | null;
    title?: string;
}

const SelectLenses: React.FC<Props> = (props) => {
    const [canNotifyClick, setCanNotifyClick] = useState(true);
    const [neckglassesModals, setNeckglassesModals] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogChildren, setDialogChildren] = useState("");
    const [isBlue] = usePackageInfoContext((state) => [state.isBlue]);
    const [toastType, setToastType] = useState<"loading" | "info">("loading");
    const [toastChildren, setToastChildren] = useState("");
    const [toastVisible, setToastVisible] = useState(false);
    const { pageId } = props;
    const { site } = useCommonContext();
    const { t } = useTranslation(["common", "productDetail"]);

    const [openModal] = signInModal.useSignInModalStore((state) => [
        state.openModal,
    ]);
    const [isDecentered] = lensObj.useInstationStore((state) => [
        state.isDecentered,
    ]);
    const [
        productDetail,
        activeObj,
        packageId,
        isRiskControl,
        changeFollow,
        changeUnderMarket,
        changeStatus,
    ] = useProductDetailsContext((state) => [
        state.productDetail,
        state.activeObj,
        state.packageId,
        state.isRiskControl,
        state.changeFollow,
        state.changeUnderMarket,
        state.changeStatus,
    ]);
    const [packageInfoisPackage, active_package, usage, type, isForceRx] =
        usePackageInfoContext((state) => [
            state.isPackage,
            state.active_package,
            state.usage,
            state.type,
            state.isForceRx,
        ]);
    const isPackage = useMemo(
        () => packageInfoisPackage && productDetail.meedPackage,
        [packageInfoisPackage, productDetail.meedPackage],
    );

    function showToast(msg: string, type: "loading" | "info" = "info") {
        setToastVisible(true);
        setToastChildren(msg);
        setToastType(type);
    }

    const addNotify = useCallback(() => {
        if (!canNotifyClick) {
            return;
        }
        if (activeObj.follow) {
            setDialogOpen(true);
            setDialogChildren(t("productDetail:Subscribed"));
            return;
        }

        setCanNotifyClick(false);
        postAccount(NOTIFY, {
            products_id: productDetail.products_id,
            products_color_id: activeObj.id,
        })
            .then(() => {
                setCanNotifyClick(true);
                setDialogOpen(true);
                setDialogChildren(t("productDetail:SubscribeSuccessfully"));
                changeFollow(activeObj.id?.toString() ?? "");
            })
            .catch((e) => {
                setCanNotifyClick(true);
                //产品下架
                e == 203002 &&
                    changeUnderMarket(activeObj.id?.toString() ?? "");
                //库存充足
                e == 203003 && changeStatus(activeObj.id?.toString() ?? "");

                e != 203002 && e != 203003 && showToast(e);
            });
    }, [
        activeObj.follow,
        activeObj.id,
        canNotifyClick,
        changeFollow,
        changeStatus,
        changeUnderMarket,
        productDetail.products_id,
        t,
    ]);

    //关注
    const onNotify = useCallback(() => {
        const is_login = isLogin();
        if (!is_login) {
            openModal(addNotify);
        } else {
            addNotify();
        }
    }, [addNotify, openModal]);

    //获取Ga统计参数
    const getGAStatistics = useCallback(() => {
        //根据 activeColorId 获取商品colorindex
        const showColorIdx = productDetail.products_color_relation?.findIndex(
            (item: any) => item.color_id === Number(activeObj.id),
        );
        //GA商品详情统计
        const pathName = window.location.pathname;
        return getProductItemParams({
            productList: [productDetail],
            colorIndex: showColorIdx !== -1 ? showColorIdx : 0,
            category: `pc_${pathName}`,
            list_name: `pc_${pathName}`,
        });
    }, [activeObj.id, productDetail]);

    //添加购物车
    const addCartGA = useCallback(() => {
        const sendData = getGAStatistics();
        sendData.length &&
            productAddToCar({
                items: sendData,
            });
        sendData.length &&
            snapProductAddToCar({
                items: sendData,
            });
    }, [getGAStatistics]);

    const addToCartNow = useCallback(() => {
        const data = {
            product_id: productDetail.products_id,
            color_id: activeObj.id,
            cart_quantity: 1,
            "id[2]": 300,
        };

        create(data)
            .then(() => {
                addToCartClickEvent({
                    colorId: activeObj.id,
                    price: activeObj.onsale?.price,
                });
                criteoAd.addToCart({
                    id: activeObj.id,
                    price: activeObj.onsale?.price,
                    quantity: 1,
                });
                location.href = "/basket";
            })
            .catch((e) => alert(e));

        //添加GA统计
        try {
            addCartGA();
        } catch (err) {
            console.log(err);
        }
    }, [
        activeObj.id,
        activeObj.onsale?.price,
        addCartGA,
        productDetail.products_id,
    ]);

    const onNeckglasses = () => {
        setNeckglassesModals(true);
    };

    const onSelectLens = useCallback(() => {
        let _query: any = {
            lensColor: activeObj.id,
            is_package: packageId,
            products_id: productDetail.products_id,
        };
        if (pageId) {
            _query.page_id = pageId;
        }

        if (isPackage) {
            _query.is_package = packageId;
            _query.usage = usage.option_value_id
                ? usage.option_value_id
                : isForceRx
                  ? -1
                  : "";
            (_query.type = type.option_value_id ? type.option_value_id : ""),
                (_query.isBlue = isBlue ? 1 : 0);
        }
        _query.changes = "eccent";
        let isOld = LensPageDiversion({
            site,
            products_model: productDetail.products_model,
            master_categories_id: productDetail.master_categories_id,
        });

        isPackage
            ? gaLensPackageEvent(
                  "select lens",
                  active_package.name ?? "not select",
              )
            : gaSelectLensBtnClick();

        gaCommonEvent("select lens_new", {
            event_category: "lenses process",
        });
        isOld
            ? gaCommonEvent("select lens old")
            : gaCommonEvent("select lens new2");

        // make queryObj to queryString
        const queryString = Object.keys(_query)
            .map((key) => {
                return `${key}=${_query[key]}`;
            })
            .join("&");
        isOld
            ? (location.href = `/lens?${queryString}`)
            : (location.href = `/newlens?${queryString}`);
    }, [
        activeObj.id,
        active_package.name,
        isBlue,
        isForceRx,
        isPackage,
        packageId,
        pageId,
        productDetail.master_categories_id,
        productDetail.products_id,
        productDetail.products_model,
        site,
        type.option_value_id,
        usage.option_value_id,
    ]);

    //选择套餐，先填写处方再加入购物车
    // const addPrescription = () => {
    //     toggePackagerModal();
    // };

    //选择套餐,加入购物车
    const addPackageToCart = ({
        rxStr,
        package_id,
    }: {
        rxStr?: string;
        package_id?: number;
    }) => {
        const { options } = active_package;
        let _package_id = 0;

        switch (usage.name) {
            case "distance":
                _package_id = options["distance"];
                break;
            case "reading":
                _package_id = options["reading"];
                break;
            case "no-pre":
                _package_id = options["no-pre"];
                break;
            default:
                break;
        }

        _package_id = _package_id ?? active_package.package_id;

        let sendData: any = {
            color_id: activeObj.id,
            product_id: productDetail.products_id,
            page_id: packageId,
            package_id: package_id ?? _package_id,
            quantity: 1,
        };

        const ids: any = getPackageUsage({ rx: rxStr, isDecentered, usage });

        showToast("", "loading");

        create({ ...sendData, ...ids }).then(
            (arg: any) => {
                //加入购物车成功，跳转购物车页面
                setToastVisible(false);
                addToCartClickEvent({
                    colorId: activeObj.id,
                    price: activeObj.onsale?.price,
                });
                criteoAd.addToCart({
                    id: activeObj.id,
                    price: activeObj.onsale?.price,
                    quantity: 1,
                });
                location.href = "/basket";
            },
            (err: any) => {
                showToast(err);
            },
        );
    };

    const gaLensPackEnvent = () => {
        gaLensPackageEvent("select lens", active_package.name);
    };

    // const toggePackagerModal = () => {
    //     setPackageModal(prev =>!prev)

    // };

    const { title } = props;
    const { p_under_market, no_rx, isNeckglasses } = productDetail;
    const { colorUnderMarket, is_notify, outOfStore } = activeObj;

    const isNotify = useMemo(
        () => is_notify && !p_under_market && !colorUnderMarket,
        [colorUnderMarket, is_notify, p_under_market],
    );

    const productBottomBtn = useMemo(() => {
        switch (true) {
            case p_under_market:
            case colorUnderMarket:
            case outOfStore:
                return (
                    <FmButton
                        disabled
                        fullWidth
                        className="product-bottom-outOfstore-colorUnderMarket-pUnderMarket"
                    >
                        {t("productDetail:SOLD_OUT")}
                    </FmButton>
                );
            case isNotify:
                return (
                    <FmButton
                        fullWidth
                        onClick={onNotify}
                        className="product-bottom-isNotify"
                    >
                        {t("productDetail:OUT_OF_NOTIFY")}
                    </FmButton>
                );

            case no_rx:
                return (
                    <FmButton
                        fullWidth
                        onClick={addToCartNow}
                        className="product-bottom-no-rx"
                    >
                        {t("common:ADD_TO_CART")}
                    </FmButton>
                );
            case isNeckglasses:
                return (
                    <FmButton
                        fullWidth
                        onClick={onNeckglasses}
                        className="product-bottom-isNeckglasses"
                    >
                        {t("common:ADD_TO_CART")}
                    </FmButton>
                );
            default:
                return (
                    <FmButton
                        id={`select_lenses_old`}
                        onClick={onSelectLens}
                        fullWidth
                        className="product-bottom-SelectLenses"
                    >
                        {title ?? t("productDetail:SelectLenses")}
                    </FmButton>
                );
        }
    }, [
        addToCartNow,
        colorUnderMarket,
        isNeckglasses,
        isNotify,
        no_rx,
        onNotify,
        onSelectLens,
        outOfStore,
        p_under_market,
        t,
        title,
    ]);
    return (
        <React.Fragment>
            <FmDrawer
                open={dialogOpen}
                anchor="bottom"
                closeablePosition="right"
                closeable
                headerChildren
                footer={
                    <FmButton
                        size={"large"}
                        fullWidth
                        onClick={() => setDialogOpen(false)}
                        variant="outlined"
                        style={{ marginTop: "0.4rem" }}
                    >
                        {"OK"}
                    </FmButton>
                }
            >
                {dialogChildren}
            </FmDrawer>
            <FmToast type={toastType} visible={toastVisible}>
                {toastChildren}
            </FmToast>
            {productBottomBtn}

            <NeckglassesModal
                open={neckglassesModals}
                addCartGA={addCartGA}
                color_id={activeObj.id!}
                product_id={productDetail.products_id!}
                pageId={props.pageId ?? null}
                onClose={() => {
                    setNeckglassesModals(false);
                }}
            />
        </React.Fragment>
    );
};

export default SelectLenses;
